// Public /contact page — a dedicated home for the enquiry form so the header
// CTA and footer "Contact" link have a stable destination outside the landing
// page's in-page #contact anchor.

import { useEffect } from 'react';
import { MarketingHeader, MarketingFooter, MARKETING_FONT } from '@/components/marketing/chrome';
import { ContactForm } from '@/components/marketing/ContactForm';
import { CircleCheck } from '@/lib/icons';

export function ContactPage() {
  useEffect(() => { document.title = 'Contact — Bugpunch'; }, []);

  return (
    <div className="min-h-screen bg-[#0a0b0d] text-white" style={{ fontFamily: MARKETING_FONT }}>
      <MarketingHeader ctaHref="/contact" />

      <section className="relative overflow-hidden">
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0"
          style={{ background: 'radial-gradient(55% 45% at 50% -10%, rgba(249,115,22,0.14), transparent 70%)' }}
        />
        <div className="relative mx-auto grid max-w-5xl items-start gap-10 px-5 py-16 sm:px-8 sm:py-24 lg:grid-cols-2">
          <div>
            <span className="text-xs font-semibold uppercase tracking-wider text-[#f97316]">Get in touch</span>
            <h1 className="mt-2 text-balance text-4xl font-semibold tracking-tight sm:text-5xl">
              Let's get your game on Bugpunch
            </h1>
            <p className="mt-5 max-w-md text-pretty text-base leading-relaxed text-white/55">
              We're onboarding studios into early access one at a time. Send us a note about your game and your
              team, and we'll set you up with a project, an SDK key, and a walkthrough.
            </p>
            <ul className="mt-7 space-y-3">
              {[
                'Personalised onboarding for your team',
                'Works with your existing Unity build pipeline',
                'Direct line to the people building Bugpunch',
                'Usually a reply within one business day',
              ].map((b) => (
                <li key={b} className="flex items-center gap-3 text-sm text-white/65">
                  <CircleCheck className="h-4 w-4 shrink-0 text-[#f97316]" />
                  {b}
                </li>
              ))}
            </ul>
            <p className="mt-8 text-sm text-white/40">
              Prefer email? Reach us at{' '}
              <a href="mailto:enquiry@bugpunch.com" className="text-white/70 underline-offset-2 hover:underline">enquiry@bugpunch.com</a>.
            </p>
          </div>

          <div className="rounded-2xl border border-white/[0.08] bg-white/[0.02] p-6 sm:p-8">
            <ContactForm source="contact-page" />
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
